<template>
<v-layout row wrap justify-center align-center no-gutters class="mt-0">
  <v-flex xs12 ma-0 class="pa-0 menu-initial" :class="{'color-menu': cambiarPosicion}">
    <div class="cont-boton boton-menu-responsive d-flex pa-1" v-if="$vuetify.breakpoint.xs">
      <v-btn
        class="mr-auto boton-burguer"
        icon
        @click.stop="drawer = !drawer"
        >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <img class="mx-auto" src="@/assets/logo-eaav-h.svg" alt="EEAV" width="100px" @click="$router.push('/')" >
    </div>
    <v-navigation-drawer v-if="$vuetify.breakpoint.xs"
      v-model="drawer"
      fixed
      temporary
      width="90vw"
      class="pos-drawer"
      >
      <div class="cont-elementos">
      <v-list-item class="cont-logo-resp" @click="$router.push('/')">
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title>
            <img src="@/assets/logo-eaav-h.svg" alt="EEAV" :width="$vuetify.breakpoint.xs ? '110px': '170px'" >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="(item,i) in itemsB"
            :key="i"
          >
            <v-expansion-panel-header class="pa-2" style="min-height:35px;!important">
              <template v-slot:actions>
                <v-icon x-small>
                  $expand
                </v-icon>
              </template>
              <span class="txt-primary">
                {{item.nombreCategoria}}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list dense>
                <v-list-item class="pa-0 ma-0" :class="i < item.subitems.length-1 ? 'bd-botom' : ''" v-for="(subitem,i) in item.subitems" :key="'sub-'+i">
                  <v-list-item-content class="pa-0" v-if="!subitem.submenu"  @click="actionBtn(i ,subitem.contenido, subitem.id_cont_cate, subitem.nombreCategoria, subitem.url, subitem.documento_filtro)">
                    <v-list-item-title>{{subitem.nombreCategoria}}</v-list-item-title>
                  </v-list-item-content>
                  <v-expansion-panels accordion v-if="subitem.submenu" >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="pa-2" style="min-height:35px;!important">
                          <template v-slot:actions>
                            <v-icon x-small>
                              $expand
                            </v-icon>
                          </template>
                          <span class="txt-primary">
                            {{subitem.nombreCategoria}}
                          </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-0">
                          <v-list dense>
                            <v-list-item class="pa-0 ma-0" :class="n < subitem.subitems.length-1 ? 'bd-botom' : ''" v-for="(sub,n) in subitem.subitems" :key="'sub-'+n">
                              <v-list-item-content class="pa-0" @click="actionBtn(i, sub.contenido, sub.id_cont_cate, sub.nombreCategoria, sub.url, sub.documento_filtro)">
                                <v-list-item-title>{{sub.nombreCategoria}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                  </v-expansion-panels>

                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-navigation-drawer>
    <v-toolbar v-else
      color="#F3F3F4"
      height="40px"
      class="text-center d-flex justify-center align-center ma-0 cont-general-menu"
      >
      <div class="cont-logo" @click="$router.push('/')">
        <img src="@/assets/logo-eaav-h.svg" alt="">
      </div>
      <v-btn
      v-for="(itemMenu , i) in itemsB" :key="'item-menu'+i"
      v-if="!itemMenu.submenu"
      text
      color="textprimary"
      >
      <span class="font-1">
        {{itemMenu.nombreCategoria}}
      </span>
        <v-icon right v-show="itemMenu.submenu">mdi-menu-down</v-icon>
      </v-btn>
      <v-menu v-else
        nudge-top="0"
        offset-y
        transition="slide-y-transition"
        v-model="menu[i]"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            tile
            v-bind="attrs"
            v-on="on"
            color="textprimary"
            class="boton-menu"
          >
          <span class="text-menu-titulo font-1">{{itemMenu.nombreCategoria}}</span>
            <v-icon right v-show="itemMenu.submenu">mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item class="px-2 py-0 cont-item-menu"
            v-for="(childItem, idx) in itemMenu.subitems"
            :key="'clhildItem-'+idx"
            @click="() => {}"
          >
          <v-list-item-content v-if="!childItem.submenu"
          @click="actionBtn(i,childItem.contenido, childItem.id_cont_cate, childItem.nombreCategoria, childItem.url, childItem.documento_filtro)">
            <v-list-item-title class="texto-menu" color="textprimary">
              {{childItem.nombreCategoria}}
            </v-list-item-title>
          </v-list-item-content>
          <v-menu v-else
              open-on-hover
              nudge-right="0"
              nudge-top="45"
              offset-x
              offset-y
              transition="slide-y-transition"
              color="textprimary"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content v-on="on" v-bind="attrs"
                @click="childItem.subitems.length >= 1 ? ()=>{} : actionBtn(i,childItem.contenido, childItem.id_cont_cate, childItem.nombreCategoria, childItem.url, childItem.documento_filtro) ">
                  <v-list-item-title class="texto-menu" color="textprimary"
                    >{{childItem.nombreCategoria}}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list dense>
                <v-list-item class="px-1 py-0 cont-item-menu"
                  v-for="(childItemChild, idx) in childItem.subitems"
                  :key="'childItemChild-'+idx"
                  @click="actionBtn(i,childItemChild.contenido, childItemChild.id_cont_cate, childItemChild.nombreCategoria, childItemChild.url , childItem.documento_filtro)"
                >
                  <v-list-item-content>
                  <v-list-item-title class="texto-menu">{{childItemChild.nombreCategoria}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>

  </v-flex>

</v-layout>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'navUser',
  props: {
    cambiarPosicion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      aItems: [],
      itemsB: [],
      textPrueba: '',
      removeAccents: '',
      drawer: false,
      menu: []
    }
  },
  async created () {
    await axios
      .get('' + this.$store.state.rutaApi + 'menu_principal_v2')
      .then(response => (this.itemsB = response.data[0].items))
    // console.log(this.itemsB)
    this.menu = Array(this.itemsB.length).fill(false)
  },
  computed: {
    ...mapGetters(['saveIdContenido'])
  },
  mounted () {
    // console.log('Preimera consulta ', this.$store.state.idContenido)

  },
  methods: {
    sinVinculo () {
      // console.log('sin vinculo')
      return false
    },
    actionBtn (num, tipo, id, name, urlexterno, filtroDoc) {
      this.$set(this.menu, num, false)
      // console.log('Desde el NavUser Nombre', this.menu)
      if (tipo) {
        if (name == 'Directivos') {
          this.$router.push({ name: 'directorio' })
        } else {
          this.$store.dispatch('saveIdContenido', id)
          this.$emit('reload')
          this.$router.push({ name: 'contenido', params: { idCont: id, catName: name } }).catch(() => {})
          // this.$store.state.idContenido = id
        }
      } else if (filtroDoc != null) {
        this.$router.push({ name: 'documentos', params: { nameFiltro: filtroDoc } }).catch(() => {})
      } else if (urlexterno != null) {
        window.location.href = urlexterno
      } else {
        let nombre = name.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '').toLowerCase()
        this.$router.push({ name: nombre })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-itemh{
  max-height: 40px;
  font-size: 0.7em!important;
  color: #2B5AC4;
}
.cont-logo{
  cursor: pointer;
  padding: 15px 10px 5px 10px;
  border-radius:0px 0px 5px 5px;
  background: white;
  margin-top: 23px;
  margin-right: 10px;
  box-shadow: 0px 4px 4px 0.5px rgba(0, 0, 0, 0.2);
  img{
    width: 130px;
  }
}
.itemHorizonal{
  display: inline-block;
}
.bdred{
  border: solid red 1px;
}
.texto-menu{
  font-size: 1em;
  color: var(--v-primary-base);
  font-weight: 600;
}
.cont-item-menu{
  min-height: 30px!important;
}
.boton-menu{
  padding: 0px 5px!important;
  min-width: 30px;
  letter-spacing: 0;
}
.cont-logo-resp{
  background: rgba(16,134,255,1);
}
.boton-menu-responsive{
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.color-menu{
  position: fixed;
  top: 0px;
  z-index: 2;
  width: 100%;
  background: #F3F3F4;
  transition: all 0.3s ease-in-out;
}
.menu-initial{
  transition: all 0.3s ease-in-out;
}
.pos-drawer{
  z-index: 1;
}
.cont-boton{
  width: 100%;
  background: #F3F3F4;
}
.boton-burguer{
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 1;
}

.bd-botom{
  border-bottom: solid 1px #F3F3F4;
}

</style>
